import { tablaMultas } from "../../../../../shared/data/tables/tabla-multas";
import {NgbdSortableHeader,} from "../../../../../shared/directives/NgbdSortableHeader";
import { BehaviorSubject } from "rxjs";
import { Component, QueryList, ViewChildren,} from "@angular/core";
import { VehiclesService } from "../../../../../shared/services/vehicles.service";
import jsPDF from "jspdf";
import { Utils } from "../../../../../shared/utils/Utils";
import {Contrato,} from "../../../../../shared/services/contrato.service";
import { DataService } from "../../../../../shared/services/municipios.service";
import { FormBuilder, FormGroup } from "@angular/forms";
const Swal = require("sweetalert2");

@Component({
  selector: 'app-departamentos-inactivos',
  templateUrl: './departamentos-inactivos.component.html',
  styleUrls: ['./departamentos-inactivos.component.scss']
})
export class DepartamentosInactivosComponent {

  pageSize1: number = 5;
  page1: number = 1;
  totalItems: number;
  public searchText: string = ""; // Texto de búsqueda
  selectedEstado: any;
  municipiosRutas: any[] = [];
  formMUNICIPIOS: FormGroup;
  filteredTableItems: VehiclesService[];
  contratos: Contrato[] = [];

  constructor(
    private dataService: DataService,
        private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.selectedEstado = "";
    this.listarDepartamentos();

    this.formMUNICIPIOS = this.fb.group({
      DEPARTAMENTO: [null],
      MUNICIPIO: [null],  // Debe coincidir con un vehículo existente
    });
  }

  avisoActivarMunicipio(MUNICIPIO: string) {
    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar el municipio: ${MUNICIPIO}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.dataService.activarMunicipio(MUNICIPIO).subscribe({
          next: (response) => {
            Swal.fire({
              icon: "success",
              title: "ACTIVADO CORRECTAMENTE",
              confirmButtonText: "Aceptar",
            });

            // ✅ Resetear formulario y recargar lista
            this.formMUNICIPIOS.reset();
            this.listarDepartamentos(); // O el método que recargue los municipios inactivos
          },
          error: (error) => {
            console.error("Error:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.error?.message || "No se pudo activar el municipio",
              confirmButtonText: "Aceptar",
            });
          },
        });
      }
    });
  }

  listarDepartamentos(): void {
    this.dataService.getDatosInactivos().subscribe({
      next: (data) => {
        if (Array.isArray(data)) {
          this.municipiosRutas = data;
          this.formMUNICIPIOS.reset();
          this.filteredTableItems = this.municipiosRutas; // ✅ Necesario para que funcione paginación y filtro
        }
      },
      error: (err) => {
        console.error("Error al cargar contratos", err);
      },
    });
  }

  filterData() {
    const search = this.searchText.toLowerCase();
    this.filteredTableItems = this.municipiosRutas.filter((item) =>
      item.MUNICIPIO?.toLowerCase().includes(search)
    );
    this.page1 = 1; // Reiniciar a la primera página al buscar
  }
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }


}